import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileImport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 43,
	viewBox: "0 0 45 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.5 18.6667L40.5 37.5C40.5 39.1569 39.1569 40.5 37.5 40.5L10.5 40.5C8.84314 40.5 7.5 39.1569 7.5 37.5L7.5 10.5C7.5 8.84314 8.84315 7.5 10.5 7.5L29.3333 7.5",
			stroke: "#B3EC49",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.5 7.5L19.5 28.5",
			stroke: "#B3EC49",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 16.5L19.5 28.5L31.5 28.5",
			stroke: "#B3EC49",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgFileImport;
